module.exports = __webpack_public_path__ + "img/goulash.98de4951.webp";